(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('app-account', {
            parent: 'entity',
            url: '/app-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.appAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-account/app-accounts.html',
                    controller: 'AppAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('app-account-detail', {
            parent: 'entity',
            url: '/app-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.appAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-account/app-account-detail.html',
                    controller: 'AppAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppAccount', function($stateParams, AppAccount) {
                    return AppAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'app-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('app-account-detail.edit', {
            parent: 'app-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-account.new', {
            parent: 'app-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                domain: null,
                                allowUserRegistration: false,
                                allowDigitalSig: false,
                                allowTwoStepAuth: false,
                                logoImg: null,
                                logoImgContentType: null,
                                watermarkImg: null,
                                watermarkImgContentType: null,
                                terms: null,
                                tplDocToSign: null,
                                tplDocComplete: null,
                                tplDocReject: null,
                                tplDocRemind: null,
                                publicUse: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('app-account');
                });
            }]
        })
        .state('app-account.edit', {
            parent: 'app-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-dialog.html',
                    controller: 'AppAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-account.delete', {
            parent: 'app-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-account/app-account-delete-dialog.html',
                    controller: 'AppAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppAccount', function(AppAccount) {
                            return AppAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-account', null, { reload: 'app-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
